export default __webpack_public_path__ + "static/media/deluxe-premium-package.302d5778.jpg";